import { isFinite } from 'lodash';
import { scaleLinear, scalePow, scaleSqrt, scaleLog } from 'd3-scale';

const scales = {
  pow: scalePow,
  linear: scaleLinear,
  log: scaleLog,
  sqrt: scaleSqrt,
};

export default (conf) => {
  const scale = scales[conf.modifier] ? scales[conf.modifier]() : scaleLinear();

  if (conf.modifier === 'pow' && conf.exponent) scale.exponent(conf.exponent);
  if (conf.modifier === 'log' && conf.base) scale.base(conf.base);

  return {
    id: conf.id,
    field: conf.field,
    options: conf,
    transformer: (domain, range) => {
      const transformer = scale.copy();
      const { nice, clamp } = transformer;

      if (domain !== undefined) {
        let [min, max] = domain.map(Number);
        const total = Math.abs(min) + Math.abs(max);
        if (conf.minPadding) min -= total * conf.minPadding;
        if (conf.maxPadding) max += total * conf.maxPadding;

        transformer.domain([min, max]);

        if (conf.nice) nice(isFinite(conf.nice) ? conf.nice : undefined);
        clamp(conf.clamp);
      }

      if (range !== undefined) {
        transformer[conf.round ? 'rangeRound' : 'range'](range);
      }

      return transformer;
    },
  };
};
